import {  IAutomationObject } from '../../../types'

export interface IP_RoomAutomation extends IAutomationObject {
    errSum: boolean;
    isOn: boolean;
    isMan: boolean;
}

export const schema = 'AutomationApps.Plants.Buildings.P_RoomAutomation';
